export default {
  methods: {
    // DEPRECATED: please see useImgUrl.js
    formatImageSize(src, size = '_612x442_crop_center') {
      if (!src) {
        return ''
      }
      const regex = /(\.jpg|\.gif)/gi
      const matches = src.match(regex)
      let i = src.search(matches[0])
      let result = src.slice(0, i) + size + src.slice(i)
      const versionRegex = /v=([0-9]+)/gi
      if (result.search(versionRegex) < 0) {
        let cacheVersion = 10 // Update to get new swatch images
        let url = new URL('https://foo.bar/' + src)
        url.searchParams.set('v', cacheVersion)
        result = url.toString().slice(16)
      }
      return result
    },
  },
}
